import { PUBLIC_APP_ENV, PUBLIC_SENTRY_DSN } from '$env/static/public';
import * as Sentry from '@sentry/sveltekit';

import { dev } from '$app/environment';

export function initSentry() {
	if (!dev) {
		Sentry.init({
			dsn: PUBLIC_SENTRY_DSN,
			environment: PUBLIC_APP_ENV,
			tracesSampleRate: 1,
			replaysSessionSampleRate: 0.1,
			replaysOnErrorSampleRate: 1,
			integrations: [
				Sentry.replayIntegration(),
				Sentry.extraErrorDataIntegration({
					depth: 32
				})
			]
		});
	}
}
